import React from 'react';

function CollabField({ data }) {
  if (!data.collab) return <>-</>;

  return <>{data.collab.name + ' ' + data.collab.surname}</>;
}

export default CollabField;
